import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Beranda from '@/components/Beranda'
import Dashboard from '@/components/dashboard/Main'

// PELANGGAN 
import Pelanggan from '@/components/pelanggan/index'
import PelangganMain from '@/components/pelanggan/main'
import PelangganMainOld from '@/components/pelanggan/main-old'
import PelangganBaru from '@/components/pelanggan/main-old'
import PelangganTelat from '@/components/pelanggan/main-telat'
import PelangganNunggak from '@/components/pelanggan/main-telat'
import PelangganDetail from '@/components/pelanggan/detail'
import PelangganTambah from '@/components/pelanggan/tambah'
import PelangganEdit from '@/components/pelanggan/edit'
import PelangganArea from '@/components/pelanggan/main-area'
import PelangganImport from '@/components/pelanggan/import'
import PelangganSingkron from '@/components/pelanggan/singkron'

// ADMIN
import Admin from '@/components/admin/index'
import AdminBerandaMain from '@/components/admin/beranda'
	// tagih
	import AdminMain from '@/components/admin/kangtagih/main'
	import AdminTambah from '@/components/admin/kangtagih/tambah'
	import AdminTambahVoucher from '@/components/admin/kangtagih/tambah'
	import AdminEdit from '@/components/admin/kangtagih/edit'
	import AdminDetail from '@/components/admin/kangtagih/detail'
	import AdminDetailMain from '@/components/admin/detail/main'
	import AdminDetailPelanggan from '@/components/admin/detail/pelanggan'
	import AdminDetailPelangganBelum from '@/components/admin/detail/pelanggan-belum'
	import AdminDetailPelangganSudah from '@/components/admin/detail/pelanggan-sudah'
	import AdminDetailPengeluaran from '@/components/admin/detail/pengeluaran'
	// TEKNISI
	import TeknisiMain from '@/components/admin/teknisi/main'
	import TeknisiTambah from '@/components/admin/teknisi/tambah'
	import TeknisiDetail from '@/components/admin/teknisi/detail'
	import TeknisiEdit from '@/components/admin/teknisi/edit'

// PELANGGAN BELUM
import PelangganBelum from '@/components/pelanggan-belum/index'
import PelangganBelumMain from '@/components/pelanggan-belum/main'
import PelangganIsolirMain from '@/components/pelanggan-isolir/main'

// PELANGGAN BELUM
import PelangganLunas from '@/components/pelanggan-lunas/index'
import PelangganLunasMain from '@/components/pelanggan-lunas/main'
import PelangganLunasNow from '@/components/pelanggan-lunas/main-now'
import PelangganLunasOnlineMain from '@/components/pelanggan-lunas/main-online'
import PelangganLunasIsolirMain from '@/components/pelanggan-lunas/main-isolir'
import PelangganLunasDetail from '@/components/pelanggan-lunas/detail'
import PelangganBerhenti from '@/components/pelanggan/berhenti'

// AREA
// import Area from '@/components/area/index'
// import AreaMain from '@/components/area/main'
// import AreaTambah from '@/components/area/tambah'

// PAKET 
// import Tarif from '@/components/tarif/index'
// import TarifMain from '@/components/tarif/main'
// import TarifTambah from '@/components/tarif/tambah'

// TARIF VOUCHER
import TarifVoucher from '@/components/tarifVoucher/index'
import TarifVoucherMain from '@/components/tarifVoucher/main'
import TarifVoucherTambah from '@/components/tarifVoucher/tambah'

// TARIF VOUCHER
import Voucher from '@/components/voucher/index'
import VoucherMain from '@/components/voucher/main'
import VoucherList from '@/components/voucher/list'
import VoucherTarif from '@/components/voucher/tarif'
import VoucherKang from '@/components/voucher/kang'
import VoucherTambah from '@/components/voucher/tambah'

// HISTORY PEMBAYARAN
import HistoryPembayaran from '@/components/history-pembayaran/index'
import HistoryPembayaranMain from '@/components/history-pembayaran/main'

// LOG DEVELOPE
import Log from '@/components/log/index'
import LogMain from '@/components/log/main'

// SETTING
import Setting from '@/components/setting/index'
import SettingMain from '@/components/setting/main'
import SettingPassword from '@/components/setting/password'
import SettingProfil from '@/components/setting/profil'
import SettingPaket from '@/components/setting/paket'
import SettingPaketTambah from '@/components/setting/paket-tambah'
import SettingArea from '@/components/setting/area'
import SettingAreaTambah from '@/components/setting/area-tambah'
import SettingInfoPrint from '@/components/setting/info-print'
import SettingInfoWA from '@/components/setting/info-wa'
import SettingSupportBy from '@/components/setting/support-by'
import SettingPPN from '@/components/setting/ppn'
import SettingSlider from '@/components/setting/slider'

// PEMBUKUAN 
import Pembukuan from '@/components/pembukuan/index'
import PembukuanDashboard from '@/components/pembukuan/dashmain'
import PembukuanMain from '@/components/pembukuan/main'
import PembukuanPengeluaran from '@/components/pembukuan/pengeluaran'
import PembukuanPengeluaranTambah from '@/components/pembukuan/pengeluaran-tambah'
import PembukuanSisa from '@/components/pembukuan/sisa'
import PembukuanRangkuman from '@/components/pembukuan/rangkuman'


// NO PAKAI
import PembukuanPeriode from '@/components/pembukuan/periode'
import PembukuanViaOnline from '@/components/pembukuan/history-via-online'
import PembukuanCash from '@/components/pembukuan/history'
import PembukuanPemasukan from '@/components/pembukuan/pemasukkan'
import PembukuanPemasukanTambah from '@/components/pembukuan/pemasukkan-tambah'

// PEMBUKUAN
import KangVoucher from '@/components/admin/kang-voucher/index'
import KangVoucherMain from '@/components/admin/kang-voucher/main'
import KangVoucherDetail from '@/components/admin/kang-voucher/detail'
import KangVoucherDetailMain from '@/components/admin/kang-voucher/detail/voucher'
import KangVoucherDetailHistory from '@/components/admin/kang-voucher/detail/history'
import KangVoucherTambahSaldo from '@/components/admin/kang-voucher/tambah-saldo'
import KangVoucherBuatkanVoucher from '@/components/admin/kang-voucher/buatkan'
import KangVoucherTambah from '@/components/admin/kang-voucher/tambah'

// PENGELUARAN
import Pengeluaran from '@/components/pengeluaran/index'
import PengeluaranMain from '@/components/pengeluaran/main'

// NETWORK
import Network from '@/components/network/index'
import NetworkMain from '@/components/network/main'

// MAP
import Mape from '@/components/map/index'
import MapeMain from '@/components/map/main'


// WhatsApp
import WA from '@/components/wa/index'
import WAMain from '@/components/wa/main'

// Mikrotik Main
import Mikrotik from '@/components/mikrotik/index'
import MikrotikMain from '@/components/mikrotik/main'
import MikrotikTambah from '@/components/mikrotik/tambah'
import MikrotikRincian from '@/components/mikrotik/rincian'
import MikrotikDetailSecret from '@/components/mikrotik/detail-secret'
import MikrotikCekPPOE from '@/components/mikrotik/cek-ppoe'

// Laporan
import Laporan from '@/components/laporan/index'
import LaporanMain from '@/components/laporan/main'
import LaporanDetail from '@/components/laporan/rincian'

// MONITOR FULL
import Monitor from '@/components/monitor'
import MonitorOff from '@/components/monitor-off'

// FORUM
import Forum from '@/components/forum/index'
import ForumMain from '@/components/forum/main'
import ForumDetail from '@/components/forum/detail'

// MITRA
import Mitra from '@/components/mitra/index'
import MitraMain from '@/components/mitra/main'
import MitraTambah from '@/components/mitra/tambah'
import MitraDetail from '@/components/mitra/detail'
import SettingPerusahaan from '@/components/mitra/perusahaan'
import MitraArea from '@/components/mitra/area'

// MITRA HISTORY
import MitraHistory from '@/components/mitra-history/index'
import MitraHistoryMain from '@/components/mitra-history/main'

// MITRA HISTORY
import ODCODP from '@/components/odcodp/index'
import ODCODPMain from '@/components/odcodp/main'
import ODCMain from '@/components/odcodp/odc'
import ODPMain from '@/components/odcodp/odp'
import ODCODPTambah from '@/components/odcodp/tambah'

// ABSENSI
import Absensi from '@/components/absensi/beranda/index'
import AbsensiMain from '@/components/absensi/beranda/main'
	// HISTORY
	import AbsensiHistory from '@/components/absensi/history/index'
	import AbsensiHistoryMain from '@/components/absensi/history/main'
	// KARYAWAN
	import AbsensiKaryawan from '@/components/absensi/karyawan/index'
	import AbsensiKaryawanMain from '@/components/absensi/karyawan/main'
	import AbsensiKaryawanDetailMain from '@/components/absensi/karyawan/detail'

// TUGAS
import Tugas from '@/components/admin/tugas/index'
import TugasMain from '@/components/admin/tugas/main'
import TugasTambah from '@/components/admin/tugas/tambah'
import TugasTotal from '@/components/admin/tugas/total'

// PENGADUAN
import Pengaduan from '@/components/pengaduan/index'
import PengaduanMain from '@/components/pengaduan/main'

// EXPORT
import Export from '@/components/export/index'
import ExportMain from '@/components/export/main'

// PENGADUAN
import Invoice from '@/components/invoice/index'
import InvoiceMain from '@/components/invoice/main'
import InvoiceHistorySaldo from '@/components/invoice/history-saldo'

// CARI CEPAT
import CariCepat from '@/components/pelanggan/cari/index'
import CariCepatMain from '@/components/pelanggan/cari/main'

// LOG ACT
import LogAct from '@/components/log-act/index'
import LogActMain from '@/components/log-act/main'

Vue.use(Router) 

export default new Router({
  routes: [
  	{	
      path: '/',
      name: 'Login',
      component: Login
    },
	{	
		path: '/mikrotik-monitor',
		name: 'mikrotik-monitor',
		component: Monitor
	},
	{	
		path: '/mikrotik-monitor-off',
		name: 'mikrotik-monitor-off',
		component: MonitorOff
	},
    {
      path: '/dashboard',
      name: '',
      component: Beranda,
      children: [
      	{
	      path: '',
	      name: 'Dashboard',
	      component: Dashboard
	    },
	    {
	      path: '/cari-cepat',
	      name: '',
	      component: CariCepat,
	      children: [
				{
					path: '',
					name: 'cari-cepat',
					component: CariCepatMain,
				}
			]
		},
	    {
	      path: '/pelanggan',
	      name: '',
	      component: Pelanggan,
	      children: [
			{
				path: '',
				name: 'pelanggan',
				component: PelangganMain,
				children: [
					{
						path: '',
						name: 'pelanggan',
							component: PelangganMainOld,
					},
					{
						path: 'belum',
						name: 'pelanggan-belum',
							component: PelangganBelumMain,
					},
					{
						path: 'lunas-bulan-ini',
						name: 'pelanggan-lunas-now',
							component: PelangganLunasNow,
					},
					{
						path: 'lunas',
						name: 'pelanggan-lunas',
							component: PelangganLunasMain,
					},
					{
						path: 'baru',
						name: 'pelanggan-baru',
							component: PelangganBaru,
					},
					{
						path: 'telat',
						name: 'pelanggan-telat',
							component: PelangganTelat,
					},
					{
						path: 'nunggak',
						name: 'pelanggan-nunggak',
							component: PelangganNunggak,
					},
					{
						path: 'lunas-online',
						name: 'pelanggan-lunas-online',
							component: PelangganLunasOnlineMain,
					},
					{
						path: 'isolir',
						name: 'pelanggan-isolir',
							component: PelangganIsolirMain,
					},
					{
						path: 'transaksi-isolir',
						name: 'pelanggan-transaksi-isolir',
						component: PelangganLunasIsolirMain,
					},
					{
						path: 'berhenti',
						name: 'pelanggan-berhenti',
						component: PelangganBerhenti,
					}
				]
			},
			{
			  path: 'area/:id',
			  name: 'pelanggan-area',
	      	  component: PelangganArea,
			},
			{
			  path: 'detail/:id',
			  name: 'pelanggan-detail',
	      	  component: PelangganDetail,
			},
			{
			  path: 'tambah/',
			  name: 'pelanggan-tambah',
	      	  component: PelangganTambah,
			},
			{
			  path: 'edit/:id',
			  name: 'pelanggan-edit',
	      	  component: PelangganEdit,
			},
			{
			  path: 'singkron/',
			  name: 'pelanggan-singkron',
	      	  component: PelangganSingkron,
			},
			{
			  path: 'import/',
			  name: 'pelanggan-import',
	      	  component: PelangganImport,
			}
	      ]
	    },
	    {
	      path: '/admin',
	      name: '',
	      component: Admin,
	      children: [
			{
			  path: '',
			  name: 'admin-beranda',
				component: AdminBerandaMain,
			},
			// tugas
			{
				path: 'tugas',
				name: 'tugas',
				  component: TugasMain,
			},
			{
				path: 'tambah-tugas',
				name: 'tugas-tambah',
				  component: TugasTambah,
			},
			{
				path: 'total',
				name: 'tugas-total',
				component: TugasTotal,
			},
			// tugas end
			{
			  path: 'kangtagih',
			  name: 'admin-kangtagih',
	      	  component: AdminMain,
			},
			{
			  path: 'tambah-kangtagih',
			  name: 'admin-tambah',
	      	  component: AdminTambah,
			},
			{
			  path: 'tambah-kangvoucher',
			  name: 'admin-tambah',
	      	  component: AdminTambahVoucher,
			},
			{
			  path: 'detail/:id',
			  name: '',
			  component: AdminDetail,
			  children: [
				  {
					path: '',
					name: 'admin-detail',
					component: AdminDetailMain,
				  },
				  {
					path: 'pelanggan',
					name: 'admin-detail-pelanggan',
					component: AdminDetailPelanggan,
				  },
				  {
					path: 'pelanggan-belum',
					name: 'admin-detail-pelanggan-belum',
					component: AdminDetailPelangganBelum,
				  },
				  {
					path: 'pelanggan-sudah',
					name: 'admin-detail-pelanggan-sudah',
					component: AdminDetailPelangganSudah,
				  },
				  {
					path: 'pengeluaran',
					name: 'admin-detail-pengeluaran',
					component: AdminDetailPengeluaran,
				  }
				]
			},
			{
			  path: 'edit/:id',
			  name: 'admin-edit',
	      	  component: AdminEdit,
			}
			,
			// teknisi
			
			{
				path: 'kangteknisi',
				name: 'admin-teknisi',
				  component: TeknisiMain
			  },
			  {
				path: 'tambah-teknisi',
				name: 'teknisi-tambah',
				  component: TeknisiTambah
			  },
			  {
				path: 'detail',
				name: 'teknisi-detail',
				  component: TeknisiDetail
			  },
			  {
				path: 'edit',
				name: 'teknisi-edit',
				  component: TeknisiEdit
			  }

			// teknisi end
	      ]
	    },
	    {
	      path: '/belum',
	      name: '',
	      component: PelangganBelum,
	      children: [
			{
			  path: '',
			  name: 'belum',
	      	  component: PelangganBelumMain,
			}
	      ]
	    },
	    {
	      path: '/lunas',
	      name: '',
	      component: PelangganLunas,
	      children: [
			{
			  path: 'detail/:id',
			  name: 'pelanggan-lunas-detail',
	      	  component: PelangganLunasDetail,
			},
			{
			  path: '',
			  name: 'lunas',
	      	  component: PelangganLunasMain,
			}
	      ]
	    },
		/*
	    {
	      path: '/area',
	      name: '',
	      component: Area,
	      children: [
			{
			  path: '',
			  name: 'area',
	      	  component: AreaMain,
			},
			{
			  path: 'tambah',
			  name: 'area-tambah',
	      	  component: AreaTambah,
			}
	      ]
	    },
		*/
		/*
	    {
	      path: '/paket',
	      name: '',
	      component: Tarif,
	      children: [
			{
			  path: '',
			  name: 'tarif',
	      	  component: TarifMain,
			},
			{
			  path: 'tambah',
			  name: 'tarif-tambah',
	      	  component: TarifTambah,
			}
	      ]
	    },
		*/
	    {
	      path: '/tarif-voucher',
	      name: '',
	      component: TarifVoucher,
	      children: [
			{
			  path: '',
			  name: 'tarifvoucher',
	      	  component: TarifVoucherMain,
			},
			{
			  path: 'tambah',
			  name: 'tambahTarifVoucher',
	      	  component: TarifVoucherTambah,
			}
		  ]
		},
	    {
	      path: '/voucher',
	      name: '',
	      component: Voucher,
	      children: [
			{
			  path: '',
			  name: 'voucher',
	      	  component: VoucherMain,
				children: [
				  	{
						path: '',
						name: 'voucher',
						component: VoucherList,
					},
					{
						path: 'tarif',
						name: 'voucher-tarif',
						component: VoucherTarif,
				  	},
					{
						path: 'kang',
						name: 'voucher-kang',
						component: VoucherKang,
					}
				]
			},
			{
			  path: 'tambah',
			  name: 'tambah-voucher',
	      	  component: VoucherTambah,
			}
		  ]
		},
	    {
	      path: '/history-pembayaran',
	      name: '',
	      component: HistoryPembayaran,
	      children: [
			{
			  path: '',
			  name: 'history-pembayaran',
	      	  component: HistoryPembayaranMain,
			}
		  ]
		},
	    {
	      path: '/log-develope',
	      name: '',
	      component: Log,
	      children: [
			{
			  path: '',
			  name: 'log',
	      	  component: LogMain,
			}
		  ]
		},
	    {
	      path: '/setting',
	      name: '',
	      component: Setting,
	      children: [
			{
			  path: '',
			  name: '',
	      	  component: SettingMain,
			  children: [
				{
					path: '',
					name: 'setting',
					component: SettingProfil
				},
				{
					path: 'password',
					name: 'password',
					component: SettingPassword
				},
				{
					path: 'profil',
					name: 'profil',
					component: SettingProfil
				},
				{
					path: 'paket',
					name: 'paket',
					component: SettingPaket
				},
				{
					path: 'paket-tambah',
					name: 'paket-tambah',
					component: SettingPaketTambah
				},
				{
					path: 'area',
					name: 'area',
					component: SettingArea
				},
				{
					path: 'area-tambah',
					name: 'area-tambah',
					component: SettingAreaTambah
				},
				{
					path: 'info-print',
					name: 'infoprint',
					component: SettingInfoPrint
				},
				{
					path: 'info-wa',
					name: 'infowa',
					component: SettingInfoWA
				},
				{
					path: 'support-by',
					name: 'supportby',
					component: SettingSupportBy
				},
				{
					path: 'ppn',
					name: 'ppn',
					component: SettingPPN
				},
				{
					path: 'slider',
					name: 'slider',
					component: SettingSlider
				}
			  ]
			}
		  ]
		},
	    {
	      path: '/pembukuan',
	      name: '',
	      component: Pembukuan,
	      children: [
			{
			  path: '',
			  name: 'pembukuan',
	      	  component: PembukuanDashboard,
			},
			{
				path: 'sisa',
				name: 'pembukuan-sisa',
				component: PembukuanSisa
			},
			{
				path: 'rincian',
				name: 'pembukuan-pengeluaran',
				component: PembukuanPengeluaran
			},
			{
				path: 'main',
				name: 'detail',
				component: PembukuanMain
			},
			{
				path: 'pengeluaran-tambah',
				name: 'pembukuan-pengeluaran-tambah',
				component: PembukuanPengeluaranTambah
			},
			{
				path: 'rangkuman',
				name: 'pembukuan-rangkuman',
				component: PembukuanRangkuman
			},


			// no pakai kebawah
			{
				path: 'xxx',
				name: 'pembukuanp',
				component: PembukuanPeriode
			},
			{
				path: 'pemasukkan',
				name: 'pembukuan-pemasukkan',
				component: PembukuanPemasukan
			},
			{
				path: 'pemasukkan-tambah',
				name: 'pembukuan-pemasukkan-tambah',
				component: PembukuanPemasukanTambah
			},
			{
				path: 'viaonline',
				name: 'pembukuan-viaonline',
				component: PembukuanViaOnline
			},
			{
				path: 'viacash',
				name: 'pembukuan-viacast',
				component: PembukuanCash
			}
			]
		},
	    {
	      path: '/pengeluaran',
	      name: '',
	      component: Pengeluaran,
	      children: [
			{
			  path: '',
			  name: 'pengeluaran',
	      	  component: PengeluaranMain
			}
			]
		},
	    {
	      path: '/kang-voucher',
	      name: '',
	      component: KangVoucher,
	      children: [
				{
					path: '',
					name: 'kang-voucher',
					component: KangVoucherMain
				},
				{
					path: 'tambah-kangvoucher',
					name: 'tambah-kangvoucher',
					component: KangVoucherTambah
				},
				{
					path: 'detail/:id',
					name: '',
					component: KangVoucherDetail,
					children: [
					  {
						  path: '',
						  name: 'detail-kang-voucher',
						  component: KangVoucherDetailMain
					  },
					  {
						  path: 'history',
						  name: 'history-kang-voucher',
						  component: KangVoucherDetailHistory
					  }
					]
				},
				{
					path: 'tambah-saldo/:id',
					name: 'kang-voucher-tambah-saldo',
					component: KangVoucherTambahSaldo
				},
				{
					path: 'buat-voucher/:id',
					name: 'kang-voucher-buatkan',
					component: KangVoucherBuatkanVoucher
				}
			]
		},
	    {
	      path: '/network',
	      name: '',
	      component: Network,
	      children: [
			{
			  path: '',
			  name: 'network',
	      	  component: NetworkMain
			}
		  ]
		},
	    {
	      path: '/map',
	      name: '',
	      component: Mape,
	      children: [
			{
			  path: '',
			  name: 'map',
	      	  component: MapeMain
			}
		  ]
		},
	    {
	      path: '/wa',
	      name: '',
	      component: WA,
	      children: [
			{
			  path: '',
			  name: 'wa',
	      	  component: WAMain
			}
		  ]
		},
	    {
	      path: '/mikrotik',
	      name: '',
	      component: Mikrotik,
	      children: [
			{
			  path: '',
			  name: 'mikrotik',
	      	  component: MikrotikMain
			},
			{
			  path: 'tambah',
			  name: 'tambah-mikrotik',
	      	  component: MikrotikTambah
			},
			{
			  path: 'rincian',
			  name: 'rincian-mikrotik',
	      	  component: MikrotikRincian
			},
			{
			  path: 'detail-secret',
			  name: 'detail-secret',
	      	  component: MikrotikDetailSecret
			},
			{
			  path: 'cek-ppoe',
			  name: 'cek-ppoe',
	      	  component: MikrotikCekPPOE
			}
		  ]
		}, // 
	    {
	      path: '/laporan',
	      name: '',
	      component: Laporan,
	      children: [
			{
			  path: '',
			  name: 'laporan',
	      	  component: LaporanMain
			},
			{
			  path: 'detail',
			  name: 'detail-laporan',
	      	  component: LaporanDetail
			},
			]
		}, // 
	    {
	      path: '/forum',
	      name: '',
	      component: Forum,
	      children: [
			{
			  path: '',
			  name: 'forum',
	      	  component: ForumMain
			},
			{
			  path: 'detail/:pid',
			  name: 'forum-detail',
	      	  component: ForumDetail
			}
		  ]
		}, // 
	    {
	      path: '/mitra',
	      name: '',
	      component: Mitra,
	      children: [
			{
			  path: '',
			  name: 'mitra',
	      	  component: MitraMain
			},
			{
			  path: 'tambah',
			  name: 'tambah-mitra',
	      	  component: MitraTambah
			},
			{
			  path: 'detail',
			  name: 'detail-mitra',
	      	  component: MitraDetail
			},
			{
				path: 'perusahaan',
				name: 'perusahaan',
				component: SettingPerusahaan
			},
			{
				path: 'mitra-area',
				name: 'mitra-area',
				component: MitraArea
			}
		  ]
		}, // 
	    {
	      path: '/mitra-history',
	      name: '',
	      component: MitraHistory,
	      children: [
			{
			  path: '',
			  name: 'mitra-history',
	      	  component: MitraHistoryMain
			}
		  ]
		}, // 
	    {
	      path: '/odcodp',
	      name: '',
	      component: ODCODP,
	      children: [
			{
			  path: '',
			  name: '',
	      	  component: ODCODPMain,
				children: [
					{
						path: '',
						name: 'odcodp',
						component: ODCMain
					},
					{
						path: 'odp',
						name: 'odp',
						component: ODPMain
					},
					{
						path: 'tambah',
						name: 'odcodp-tambah',
						component: ODCODPTambah
					}
				]
			}
		  ]
		},
	    {
			path: '/absensi',
			name: '',
			component: Tugas,
			children: [
			  	{
					path: '',
					name: 'absensi',
					component: AbsensiMain
			  	},
				{
					path: 'history',
					name: 'absensi-history',
					component: AbsensiHistoryMain,
				},
				// karyawan
				{
					path: 'karyawan',
					name: 'absensi-karyawan',
					component: AbsensiKaryawanMain,
				},
				{
					path: 'karyawan-detail/:id',
					name: 'absensi-karyawan-detail',
					component: AbsensiKaryawanDetailMain,
				},
				// karyawan end
			]
		},
	    {
			path: '/pengaduan',
			name: '',
			component: Pengaduan,
			children: [
			  {
				path: '',
				name: 'pengaduan',
				  component: PengaduanMain,
			  },
			]
		},
	    {
			path: '/export',
			name: '',
			component: Export,
			children: [
			  {
				path: '',
				name: 'export',
				  component: ExportMain,
			  },
			]
		},
	    {
			path: '/invoice',
			name: '',
			component: Invoice,
			children: [
			  {
				path: '',
				name: 'invoice',
				  component: InvoiceMain,
			  },
			  {
				path: 'history-saldo',
				name: 'invoice-history-saldo',
				  component: InvoiceHistorySaldo,
			  },
			]
		},
	    {
			path: '/log-act',
			name: '',
			component: LogAct,
			children: [
			  {
				path: '',
				name: 'logact',
				  component: LogActMain,
			  }
			]
		}
      ]
    }
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js